import config from './config';
import {
    getWildCardStatus,
    getBoosterStatus,
} from "./helper-common";

export function isBoosterTaken(type, teamData, userSpecificFixtures, currentActiveFixture){
    let isTaken = false;
        const currentFixture = userSpecificFixtures[(currentActiveFixture || 0)];
        const { GDID } = currentFixture;
        if(type==="IsWildCardTaken"){
            const wildCardStatus = getWildCardStatus(teamData, GDID);
            isTaken = (wildCardStatus === config.wildCardStatus["usedInCurrent"] || wildCardStatus === config.wildCardStatus["usedInCurrentTemp"]);
        } else if(type==="IsBoosterOneTaken") {
            const limitlessStatus = getBoosterStatus(teamData, GDID);
            isTaken = (limitlessStatus === config.limitlessBoosterStatus["usedInCurrent"] || limitlessStatus === config.limitlessBoosterStatus["usedInCurrentTemp"]);
        }
    return isTaken;
}


// WEBPACK FOOTER //
// ./src/helper-booster.js